import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { ContextMenuService } from './context-menu.service';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss']
})
export class ContextMenuComponent implements OnInit {
  @Input() disabled: boolean = false;
  @Input() dataTestId: string = 'banner-context-menu';
  @Input() ariaLabel: string;
  @Input() menuId: string;

  showOptions: boolean;

  @Input() hasCircle: boolean = false;
  @Input() label: string = '';
  constructor(
    private readonly service: ContextMenuService,
    private readonly elementRef: ElementRef
  ) {}

  @HostListener('document:click', ['$event.target'])
  public onPageClick(targetElement: HTMLElement) {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside || targetElement.hasAttribute('context-menu-option')) {
      this.showOptions = false;
    }
  }

  ngOnInit(): void {
    this.service.hideMenu.subscribe(x => {
      this.showOptions = false;
    });
  }

  toggleOptions() {
    this.showOptions = !this.showOptions;
  }
}
